/* eslint no-useless-escape: 0 */

const nj = "You broke all your favorite bones\nWhen I told you not to go\nBut you did anyway\nThey sent in the ransome note\nClipped words to clear their throats\nEnjoy your stay\nBut if they don\'t make it right\nI\'ll snuff out their greedy side\nShow your face\nTo alleviate the pressure\nThey\'re going to melt the ice and show\nI heard a crack this morning\nThe tide\'s at my back door"

export default nj;